import { ReactNode } from 'react'
import { TFunction } from 'i18next'

import { logger } from '@percent/workplace-giving/utils/logger'
import { ReactComponent as AnimalsEnvironment } from '@percent/workplace-giving/assets/icons/activity-tags/animals-environment.svg'
import { ReactComponent as ArtsCulture } from '@percent/workplace-giving/assets/icons/activity-tags/arts-culture.svg'
import { ReactComponent as JobsBusiness } from '@percent/workplace-giving/assets/icons/activity-tags/jobs-business.svg'
import { ReactComponent as Humanitarian } from '@percent/workplace-giving/assets/icons/activity-tags/humanitarian.svg'
import { ReactComponent as DisasterRelief } from '@percent/workplace-giving/assets/icons/activity-tags/disaster-relief.svg'
import { ReactComponent as Health } from '@percent/workplace-giving/assets/icons/activity-tags/health.svg'
import { ReactComponent as InternationalAid } from '@percent/workplace-giving/assets/icons/activity-tags/international-aid.svg'
import { ReactComponent as LawAdvocacy } from '@percent/workplace-giving/assets/icons/activity-tags/law-advocacy.svg'
import { ReactComponent as MilitaryVeterans } from '@percent/workplace-giving/assets/icons/activity-tags/military-veterans.svg'
import { ReactComponent as Philanthropy } from '@percent/workplace-giving/assets/icons/activity-tags/philanthropy.svg'
import { ReactComponent as Religion } from '@percent/workplace-giving/assets/icons/activity-tags/religion.svg'
import { ReactComponent as Education } from '@percent/workplace-giving/assets/icons/activity-tags/education.svg'
import { ReactComponent as Science } from '@percent/workplace-giving/assets/icons/activity-tags/science.svg'
import { ReactComponent as Welfare } from '@percent/workplace-giving/assets/icons/activity-tags/welfare.svg'
import { ReactComponent as Sports } from '@percent/workplace-giving/assets/icons/activity-tags/sports.svg'

const iconMap: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  'animals-environment': AnimalsEnvironment,
  'arts-culture': ArtsCulture,
  'jobs-business': JobsBusiness,
  humanitarian: Humanitarian,
  'disaster-relief': DisasterRelief,
  health: Health,
  'international-aid': InternationalAid,
  'law-advocacy': LawAdvocacy,
  'military-veterans': MilitaryVeterans,
  philanthropy: Philanthropy,
  religion: Religion,
  education: Education,
  science: Science,
  welfare: Welfare,
  sports: Sports
}

export const getActivityTagIcon = (slug: string): ReactNode | undefined => {
  const Icon = iconMap[slug]

  if (!Icon) {
    logger(new Error(`No activity tag icon found for slug: "${slug}"`))
  }

  return Icon ? <Icon /> : undefined
}

export const getActivityTagLabel = (t: TFunction, slug: string, fallback: string): string => {
  const key = `workplace_giving.search.activityTags.${slug}`
  const translated = t(key, { defaultValue: '' })

  return translated || fallback
}
